<template>
<div>
  <el-table
    :data="auditList"
  >
    <el-table-column
      prop="id"
      label="订单ID">
    </el-table-column>
    <el-table-column
      min-width="60"
      label="时间">
      <template slot-scope="scope">
        {{scope.row.createTime | moment}}
      </template>
    </el-table-column>
    <el-table-column
      label="账号"
    >
      <template slot-scope="scope">
        <a
          class="account-link"
          @click="getUserDetail(scope.row.userId)"
        >
          {{scope.row.userId}}
        </a>
      </template>
    </el-table-column>
    <el-table-column
      prop="coinType"
      label="币种">
    </el-table-column>
    <el-table-column
      prop="amount"
      label="数量">
    </el-table-column>
    <el-table-column
      prop="status"
      label="状态">
      <template slot-scope="scope">
        <el-tag 
          :type="scope.row.__status.color" 
        >
          {{scope.row.__status.text}}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column
      prop="note"
      show-overflow-tooltip
      label="备注">
    </el-table-column>
    <el-table-column
      label="操作" fixed="right" width="150">
      <template slot-scope="scope" >
        <el-tooltip content="审核通过" v-if="scope.row.status === 2">
          <el-button 
            type="success" 
            @click="approveAudit(scope.row)"
            icon="el-icon-success"
            size="small"
            circle
          >
          </el-button>
        </el-tooltip>
        <el-tooltip content="拒绝" v-if="scope.row.status === 2">
          <el-button 
            type="danger" 
            @click="rejectAudit(scope.row)"
            icon="el-icon-error"
            size="small"
            circle
          >
          </el-button>
        </el-tooltip>
        <el-button 
          v-if="[0, 4].includes(scope.row.status)"
          type="danger" 
          @click="cancelAudit(scope.row.id)"
          size="small"
        >
        取消订单
        </el-button>
      </template>
    </el-table-column>
  </el-table>
  <div class="pager-wrap" style="text-align:right;margin:10px 0px;">
    <pagination
        :size="pagination.size"
        :page="pagination.page"
        :total="audistCount"
        @pageChanged="handleCurrentChange"
        >
    </pagination>
  </div>
  <div class="user-withdrawal-records-wrap">
    <el-dialog
      :visible.sync="showUserDialog"
      width="1200px">
        <withdraw-records v-if="showUserDialog" :uid="nowUserId"></withdraw-records>
    </el-dialog>
  </div>
  <div class="send-trans-dialog">
    <el-dialog
      :visible.sync="ifShowSendDialog"
      @close="closeSendDialog"
      width="800px">
      <el-form :model="sendTransForm" ref="sendTransForm" label-width="100px">
        <el-form-item
          prop="transId"
          label="网络ID"
          :rules="[
            {required: true, message: '请输入网路ID'}
          ]">
          <el-input v-model="sendTransForm.transId"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="sendTransNow()">确定提交</el-button>
          <el-button @click="closeSendDialog()">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import WithdrawRecords from '../records';
import Pagination from 'components/pagination';

export default {
  name: 'AuditList',
  data() {
    return {
      showUserDialog: false,
      ifShowSendDialog: false,
      nowUserId: '',
      sendOrderId: '',
      sendTransForm: {
        id: ''
      },
      retryableStatus: [
        'FAIL_CANNOT_RETRY',
        'EXECUTING_WITHDRAW',
        'HOT_NOT_ENOUGH_MONEY',
        'DUPLICATE_TO_ADDRESS'
      ]
    };
  },
  computed: {
    ...mapState('merchantAudit', [
      'auditList',
      'allCoins',
      'audistCount',
      'pagination'
    ]),
    ...mapState(['userInfo'])
  },
  methods: {
    ...mapActions('merchantAudit', [
      'approve',
      'cancel',
      'resetUserRecords',
    ]),
    showPrompt(content, audit, callback) {
      return this.$prompt(content, '提示', {
        inputPlaceholder: '备注信息',
        inputValue: audit.note
      }).then(({ value }) => {
        return callback(value)
          .then(() => {
            this.$message({
              message: '操作成功！',
              type: 'success'
            });
            this.refreshList();
          });
      });
    },
    approveAudit(audit) {
      this.showPrompt('确认通过审核吗？', audit, (note) => this.approve({id: audit.id, note, status: 3}));
    },
    rejectAudit(audit) {
      this.showPrompt('确认拒绝通过吗？', audit, (note) => this.approve({id: audit.id, note, status: -3}))
    },
    cancelAudit(id) {
      this.$confirm('确认取消订单吗？', '提示', {
      }).then(() => {
        this.cancel(id)
          .then(() => {
            this.$message({
              message: '操作成功！',
              type: 'success'
            });
            this.refreshList();
          });
      });
    },
    getUserDetail(uid) {
      this.nowUserId = uid;
      this.showUserDialog = true;
    },
    refreshList() {
      this.handleCurrentChange({
        page: 1
      });
    },
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    },
    closeSendDialog() {
      this.$refs['sendTransForm'] && this.$refs['sendTransForm'].resetFields();
      this.ifShowSendDialog = false;
    }
  },
  components: {
    WithdrawRecords,
    Pagination
  }
};
</script>

<style lang="less" scoped>
@import url('~styles/variables.less');

.account-link,
.network-link {
  color: @color-primary;
  &:hover {
    text-decoration: underline;
  }
}
</style>
